var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScienceSubsec3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 118,
    viewBox: "0 0 119 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2726_45531)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59,
    r: 35,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0957 39.841C57.5469 39.8229 56.988 39.8336 56.4261 39.8747C47.5002 40.5283 41.1257 49.0839 42.4367 57.937C43.4295 64.6377 47.9995 64.6567 47.9995 72.8773V74.3335C47.9995 76.4514 49.7149 78.1668 51.8328 78.1668H61.4162C63.5341 78.1668 65.2495 76.4514 65.2495 74.3335V72.4168H69.0828C71.2008 72.4168 72.9162 70.7014 72.9162 68.5835V62.8747L75.6489 61.7217C76.6475 61.3019 77.0289 60.0829 76.4463 59.1686L72.8226 53.486C72.0026 45.9767 65.7635 40.0931 58.0957 39.841Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2726_45531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6525 55.2441C63.6842 55.0066 63.7 54.7612 63.7 54.4999C63.7 54.2466 63.6842 53.9932 63.6446 53.7557L65.2517 52.5049C65.3942 52.3941 65.4338 52.1803 65.3467 52.022L63.8267 49.3937C63.7317 49.2195 63.5338 49.1641 63.3596 49.2195L61.4675 49.9795C61.0717 49.6787 60.6521 49.4253 60.185 49.2353L59.9 47.2245C59.8683 47.0345 59.71 46.8999 59.52 46.8999H56.48C56.29 46.8999 56.1396 47.0345 56.1079 47.2245L55.8229 49.2353C55.3558 49.4253 54.9283 49.6866 54.5404 49.9795L52.6483 49.2195C52.4742 49.1562 52.2763 49.2195 52.1813 49.3937L50.6692 52.022C50.5742 52.1882 50.6058 52.3941 50.7642 52.5049L52.3713 53.7557C52.3317 53.9932 52.3 54.2545 52.3 54.4999C52.3 54.7453 52.3158 55.0066 52.3554 55.2441L50.7483 56.4949C50.6058 56.6057 50.5663 56.8195 50.6533 56.9778L52.1733 59.6062C52.2683 59.7803 52.4663 59.8357 52.6404 59.7803L54.5325 59.0203C54.9283 59.3212 55.3479 59.5745 55.815 59.7645L56.1 61.7753C56.1396 61.9653 56.29 62.0999 56.48 62.0999H59.52C59.71 62.0999 59.8683 61.9653 59.8921 61.7753L60.1771 59.7645C60.6442 59.5745 61.0717 59.3212 61.4596 59.0203L63.3517 59.7803C63.5258 59.8437 63.7238 59.7803 63.8188 59.6062L65.3388 56.9778C65.4338 56.8037 65.3942 56.6057 65.2438 56.4949L63.6525 55.2441ZM58 57.3499C56.4325 57.3499 55.15 56.0674 55.15 54.4999C55.15 52.9324 56.4325 51.6499 58 51.6499C59.5675 51.6499 60.85 52.9324 60.85 54.4999C60.85 56.0674 59.5675 57.3499 58 57.3499Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2726_45531",
    x: 0.5,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2726_45531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2726_45531",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2726_45531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(48.5 45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceSubsec3);
export default __webpack_public_path__ + "static/media/science_subsec_3.f4b11fc251dcd8ba39bc34b00dcf3743.svg";
export { ForwardRef as ReactComponent };